
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 166 190","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.99 52.859c1.408 47.599 32.806 101.377 76.029 130.136 42.537-27.928 74.544-82.783 75.991-130.136-34.501-11.942-57.217-29.553-70.964-40.21-1.866-1.437-3.58-2.778-5.084-3.893-2.114 1.53-4.475 3.344-7.083 5.347C61.674 25.006 40.463 41.295 6.989 52.86z","stroke":"#fff","stroke-width":"7","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M90.295 128.076c-3.677 2.598-8.764 1.763-11.394-1.896L46.948 82.019a8.109 8.109 0 011.906-11.34c3.677-2.597 8.764-1.763 11.394 1.897l24.446 33.77 11.908-20.782c2.248-3.886 7.24-5.214 11.146-2.976a8.1 8.1 0 012.992 11.092l-18.12 31.836c-2.249 3.887-7.24 5.215-11.147 2.977","stroke":"#fff","stroke-width":"7","stroke-miterlimit":"10"}})])
          )
        }
      }
    